import i18next from 'i18next';
import { __ } from '@99designs/i18n';
import { Currency, toUnit } from './currency';

type PriceFormatOptions = {
    maximumFractionDigits?: number;
    signDisplay?: 'auto' | 'always' | 'never' | 'exceptZero' | 'accounting';
};

function formatPrice(
    value: number,
    currency: Currency,
    { maximumFractionDigits = 0, signDisplay = 'auto' }: PriceFormatOptions
) {
    return i18next.t(`{{val, currency(${currency})}}`, {
        val: value,
        formatParams: {
            val: {
                maximumFractionDigits,
                signDisplay,
            },
        },
    });
}

// This price function expects the amount to be in cents it also doesn't allow
// for decimal places. Mostly used for legacy catalog pricing.
export function PriceFromCents({
    amount,
    currency,
    decimalPlaces,
    withSign,
}: {
    amount: number;
    currency: Currency;
    decimalPlaces?: number;
    withSign?: boolean;
}) {
    return formatPrice(toUnit(amount, currency), currency, {
        maximumFractionDigits: decimalPlaces,
        signDisplay: withSign ? 'always' : 'auto',
    });
}

// This price function expects the amount to be in float, as returned by website
// pricing, it allows for decimal places
export function PriceFromFloat({
    amount,
    currency,
    zeroPriceLabel,
    showSign = false,
}: {
    amount: number;
    currency: Currency;
    zeroPriceLabel?: string;
    showSign?: boolean;
}) {
    if (amount === 0.0) {
        return zeroPriceLabel || __('Not available');
    }

    return (
        <>
            {formatPrice(amount, currency, {
                maximumFractionDigits: 2,
                signDisplay: showSign ? 'always' : 'auto',
            })}
        </>
    );
}
